import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'

export default function FixturesList() {
  const [fixtures, setFixtures] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchFixtures = async () => {
      const { data } = await supabase
        .from('fixtures').select('*').order('match_date', { ascending: false })
      if (data) setFixtures(data)
      setLoading(false)
    }
    fetchFixtures()
  }, [])

  if (loading) {
    return (
      <div className="text-gray-500 text-sm uppercase tracking-widest text-center py-10">
        Loading fixtures...
      </div>
    )
  }

  return (
    <div className="mt-6 lg:mt-10">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">
        All Fixtures
      </div>
      <div className="flex flex-col gap-3">
        {fixtures.map((fixture) => (
          <div
            key={fixture.id}
            className={`border px-4 sm:px-6 py-4 sm:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6 ${
              fixture.status === 'scheduled'
                ? 'bg-green-50 dark:bg-green-950/20 border-green-200 dark:border-green-900/40'
                : 'bg-gray-50 dark:bg-white/5 border-gray-200 dark:border-white/10'
            }`}
          >
            {/* Status */}
            <div className={`text-xs font-bold uppercase tracking-widest shrink-0 ${
              fixture.status === 'scheduled' ? 'text-green-600 dark:text-green-400' : 'text-gray-400'
            }`}>
              {fixture.status === 'scheduled' ? 'UPCOMING' : 'FT'}
            </div>

            {/* Teams and Score */}
            <div className="flex-1 flex items-center gap-3 sm:gap-4 justify-center w-full sm:w-auto">
              <div className="font-black uppercase text-base sm:text-lg tracking-tight text-right flex-1 text-gray-900 dark:text-white truncate">
                {fixture.home_team}
              </div>
              <div className={`font-black text-xl sm:text-2xl min-w-12 sm:min-w-16 text-center shrink-0 ${
                fixture.status === 'scheduled' ? 'text-green-600 dark:text-green-500' : 'text-gray-900 dark:text-white'
              }`}>
                {fixture.status === 'completed'
                  ? `${fixture.home_score} - ${fixture.away_score}`
                  : 'VS'}
              </div>
              <div className="font-black uppercase text-base sm:text-lg tracking-tight flex-1 text-gray-900 dark:text-white truncate">
                {fixture.away_team}
              </div>
            </div>

            {/* Date and Venue */}
            <div className="text-xs text-gray-500 sm:text-right w-full sm:w-auto sm:min-w-36">
              <div>
                {new Date(fixture.match_date).toLocaleDateString('en-US', {
                  month: 'short', day: 'numeric', year: 'numeric',
                })}
              </div>
              <div className="mt-0.5">{fixture.venue}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}